import keyBy from 'lodash/keyBy';
import {PEOPLE__LOADED_GROUP, PEOPLE__LOADED_GROUPS} from 'app/AppConstants';

const initialState = () => ({
  groups: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case PEOPLE__LOADED_GROUP: {
      const {group} = action.payload;
      return {
        ...state,
        groups: {
          ...state.groups,
          [group.id]: group,
        },
      };
    }
    case PEOPLE__LOADED_GROUPS:
      return {
        ...state,
        groups: {...state.groups, ...keyBy(action.payload.groups, 'id')},
      };
    default:
      return state;
  }
};
